import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions, manageActions } from '../../../../../store/actions'
import Input from '../../../../../module/input'

const Certapply = (props) => {
  // const { certapply } = props

  const [state, setState] = useState({
    registNo: '',
    uthUserId: '',
  })
  //console.log('packageId = ', props.packageId);

  useEffect(() => {
    document.getElementById('certapplyBox').focus()
  }, [])

  useEffect(() => {
    //문서 채번 콜백
    if (props.totalData?.step1?.docid) {
      sessionStorage.setItem(props.totalData?.step1.docid, JSON.stringify(props.totalData))
      if (props.packageId === 0) {
        window.location.replace('/service/certapply/1?id=' + props.totalData?.step1.docid)
      } else {
        props.onSelect(props.totalData?.step1.crtIssueSeq)
      }
    }

    props.getGroupInfo()
  }, [props.totalData])

  //사업자 정보 조회
  useEffect(() => {
    props.isSearch &&
      setState({
        ...state,
        registNo: props.groupInfo?.groupRegistno,
      })
  }, [props.isSearch])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleClose = () => {
    //props.onClose()
    window.location.replace('/service/certmng')
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '1',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '2',
    display: 'block',
  }

  return (
    <React.Fragment>
      <div style={style}></div>
      <div style={styleModal} className="modal w450">
        <div className="modal-head">
          <h2>구매확인서 발급신청</h2>
        </div>

        <div className="modal-cont" id="certapplyBox" tabIndex="0">
          <h2>uTrade 서비스 정보 확인</h2>
          <dl className="dl-form">
            <dt>사업자번호</dt>
            <dd>
              <Input
                readOnly={true}
                type={'text'}
                id="registNo"
                name="registNo"
                className="form-control input-text"
                placeholder="사업자번호"
                inputTitle={'사업자번호'}
                message={'사업자번호'}
                length={10}
                value={state.registNo}
                onChange={handleChange}
                required={true}
                flow={'up'}
              />
            </dd>
          </dl>
          <div className="btn-block center">
            <button type="button" className="btn-secondary md b-close" onClick={handleClose}>
              취소
            </button>
            <button type="button" className="btn-primary md b-close" onClick={() => props.getDocNum(state)}>
              확인
            </button>
          </div>

          <button type="button" className="modal-close b-close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    certapply: state.certapply,
    totalData: state.certapply.data,
    groupInfo: state.manage?.data,
    isSearch: state.manage?.isSearch,
  }
}

const actionCreators = {
  load: certapplyActions.load,
  getGroupInfo: manageActions.getGroupInfo,
  toggleType: certapplyActions.toggleType,
  close: certapplyActions.close,
  getDocNum: certapplyActions.getDocNum,
  success: alertActions.success,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(Certapply)
